import styled from "styled-components";
import {animations, colors, devices, fonts} from "../../utils/styled/_variables.styled";

const ContactTeaserBar = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;

  .background-image {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: calc(100%);
    overflow: hidden;

    img {
      position: absolute;
      width: 100%;
      height: calc(100%);
			object-fit: cover;
    }

  }

  .contact__container{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contact__content {
    padding-top: 75px;
    @media ${devices.tabletLarge} {
      height: fit-content;
      padding: 50px;
      max-width: 1215px;
      width:100%;
    }

		@media ${devices.mobile} {
			padding: 133px 25px;
		}

    .contact__banner {
      border-radius: 8px;
      width: 644px;
      position: relative;
      background-color: ${colors.limeGreen};
      transition: all .5s ease-out;
      padding: 70px;
      margin-bottom: 115px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      transform: none;

      @media ${devices.tabletLarge} {
        width: unset;
        margin-left: unset;
        padding: 36px 48px;
        margin-bottom: unset;
        transform: unset;
      }

      @media ${devices.mobile} {
        padding: 32px 24px;
        transform: unset;
      }

			button svg {
          width: 11px;
        }

      &:hover {
        background-color: ${colors.limeGreen};

        h4 {
          opacity: 0.64;
        }
        .contact__user{
          opacity: 0.64;
        }

        button svg {
          transform: translate(4px,-50%);
        }
      }

      &:active {
        background-color: ${colors.limeGreen};
        .contact__button {
          > a {
            color: ${colors.darkGrayBlue};
            > svg path {
              fill: ${colors.darkGrayBlue};
            }
          }
        }
      }

      > h4 {
        color: ${colors.darkGrayBlue};
        font-weight: 400;
        z-index: 1;
        white-space: pre-line;
        transition: opacity .3s ease;
				font-family: ${fonts.AeonikPro};
				font-size: 47.718px;
				line-height: 110%;
				letter-spacing: -0.954px;
				margin-bottom: 108px;

        @media ${devices.tabletLarge} {
          font-size: 27px;
					margin-bottom: 63px;
        }
      }

      .contact__user {
        display: flex;
        margin-bottom: 120px;
        margin-top: 40px;
        z-index: 1;
        transition: opacity .3s ease;

        @media ${devices.tabletLarge} {
          margin-bottom: 104px;
          margin-top: 36px;
        }

        @media ${devices.mobile} {
          margin-bottom: 88px;
          margin-top: 32px;
        }

        > img {
          width: 128px;
          height: 128px;

          @media ${devices.tabletLarge} {
            width: 112px;
            height: 112px;
          }

          @media ${devices.mobile} {
            width: 80px;
            height: 80px;
          }
        }

        .contact__info {
          display: flex;
          flex-direction: column;
          margin: 40px 24px;
          @media ${devices.tabletLarge} {
            margin: 32px 20px;
          }

          @media ${devices.mobile} {
            margin: 4px 20px;
          }

          > h6 {
            color: ${colors.darkGrayBlue};
            font-weight: 600;
          }
          > p {
            color: ${colors.darkGrayBlue};
            opacity: 0.72;
            font-weight: 300;
          }
        }
      }

      .contact__button {
        height: 24px;
        width: -webkit-fill-available;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        button {
          background-color: ${colors.darkGray};
          border-radius:50px;
          padding: 20px;
          font-weight: 200;
          font-size: 12.73px;

          @media ${devices.tabletLarge} {
            font-size: 10.94px;
          }

          @media ${devices.mobile} {
            font-size: 10.94px;
          }
        }

        &:hover{
          > * {
            color: ${colors.white};
            opacity: 0.64;

            svg {
              transform: ${animations.cta};

              path {
                fill: ${colors.white};
                opacity: 0.64;
              }
            }
          }
        }

        svg {
          transition: all .3s ease-out;

          path {
            transition: all .3s ease-out;
          }
        }

        @media ${devices.tabletLarge} {
          align-items: flex-start;

        }

        @media ${devices.mobile} {
          align-items: flex-start;
        }
      }
    }
  }
`;

export { ContactTeaserBar };
